import { SKU } from "@/data/types";

import { DEFAULT_NETWORK } from "./chains";

export type PreviewParams = Partial<ReturnType<typeof getPreviewParamsFromSKU>>;

export const getPreviewParamsFromSKU = (sku: SKU) => {
  return {
    name: sku.name ?? undefined,
    notes: sku.notes ?? undefined,
    description: sku.description ?? undefined,
    image_url: sku.image_url ?? undefined,
    animation_url: sku.animation_url ?? undefined,
    header_logo_url: sku.header_logo_url ?? undefined,
    builder_io_url: sku.builder_io_url ?? undefined,
    builder_io_api_key: sku.builder_io_api_key ?? undefined,
    login_type: sku.login_type,
    redirect_url: sku.redirect_url ?? undefined,
    nft_chain_id: String(sku.nft_chain_id ?? DEFAULT_NETWORK),
    page_type: sku.page_type,
    nft_token_id: 1,
    total_tags_count: sku.tags_count,
    page_content: sku.page_content,
  };
};
